import { lazy, Suspense, useState } from "react";
import { Container, ListGroup, Row, Col, Card } from "react-bootstrap";
const URLShortener = lazy(() => import("./url-shortner"));
const FakeUser = lazy(() => import("./FakeUser"));
const QrCode = lazy(() => import("./QrCode"));
const Now = lazy(() => import("./Now"));
const CryptoSentiment = lazy(() => import("./Crypto_Sentiment"));
const ColorScheme = lazy(() => import("./ColorScheme"));

const tabs = {
  URL_SHOTERNER: "Url Shortner",
  FAKE_USER: "Fake User",
  QR_CODE: "Generate Qr code",
  CRYPTO_SENTIMENT: "Crypto Sentiment Analysis",
  COLOR_SCHEME: "Color Scheme Generator",
  NOW: "Now",
};

const TABS_LIST = [
  {
    name: tabs.URL_SHOTERNER,
    component: <URLShortener />,
  },
  {
    name: tabs.FAKE_USER,
    component: <FakeUser />,
  },
  {
    name: tabs.QR_CODE,
    component: <QrCode />,
  },
  {
    name: tabs.CRYPTO_SENTIMENT,
    component: <CryptoSentiment />,
  },
  {
    name: tabs.COLOR_SCHEME,
    component: <ColorScheme />,
  },
  {
    name: tabs.NOW,
    component: <Now />,
  },
];

export default function SplitContentView(props) {
  const [currentTabName, setCurrentTabName] = useState(tabs.URL_SHOTERNER);
  const onTabItemClick = (tabName) => {
    setCurrentTabName(tabName);
  };
  const currentTabContent =
    currentTabName &&
    TABS_LIST.filter((item) => item.name === currentTabName)[0];
  return (
    <Container className="split-content">
      <Row>
        <Col sm={3}>
          <ListGroup variant="flush" defaultActiveKey={currentTabName}>
            <ListGroup.Item className="split-content-list-item list-item-title">
              Tools
            </ListGroup.Item>
            {TABS_LIST.map((tab, index) => {
              return (
                <ListGroup.Item
                  action
                  className="split-content-list-item"
                  key={tab.name + index}
                  onClick={() => onTabItemClick(tab.name)}
                  active={currentTabName === tab.name}
                >
                  {tab.name}
                </ListGroup.Item>
              );
            })}
          </ListGroup>
        </Col>
        <Col sm={9}>
          {currentTabContent && (
            <Suspense fallback={Loading} eventKey={currentTabName}>
              <Card className="split-content-body" body>
                {currentTabContent?.component}
              </Card>
            </Suspense>
          )}
        </Col>
      </Row>
    </Container>
  );
}

const Loading = <div>...Loading</div>;
